import { AboutCopy } from './HomePage';

export default function AboutPage() {
  return (
    <main>
      <section className="section about-section">
        <h2 className="section-title">About</h2>
        <AboutCopy />
      </section>
    </main>
  );
}
